module.exports = __webpack_public_path__ + "img/ticket-star.d15c5a3e.svg";